import React from "react"

export default function DoorSelect() {
  return (
    <symbol id="svg-select-door" viewBox="-6 -3 32 32">
      <path
        fill="currentColor"
        d="M14.15 23.678h2.5v-21h-2.5v21zm-1.1 0v-22.1l-11.7 1.2v20.9h11.7zm1.2-22.1h3.6v23.3H.25v-23.1l14-1.5v1.3zm-3.8 10.6c-.1 0-.3.1-.3.3 0 .2.2.3.3.3.1 0 .3-.2.3-.3 0-.1-.1-.3-.3-.3zm.1 1.8c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5-.7 1.5-1.5 1.5z"
      />
    </symbol>
  )
}
